"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetPerformanceNotifications = exports.removedPerformanceNotification = exports.updatedPerformanceNotification = exports.addedPerformanceNotification = exports.setPerformanceNotifications = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {
    notifications: [],
};
const performanceNotificationsSlice = (0, toolkit_1.createSlice)({
    name: 'performanceNotifications',
    initialState,
    reducers: {
        setPerformanceNotifications: (_state, action) => {
            _state.notifications = action.payload ?? [];
        },
        addedPerformanceNotification: (state, action) => {
            state.notifications.push(action.payload);
        },
        updatedPerformanceNotification: (state, action) => {
            const index = state.notifications.findIndex((notification) => notification.id === action.payload.id);
            if (index < 0)
                return;
            state.notifications[index] = action.payload;
        },
        removedPerformanceNotification: (state, action) => {
            state.notifications = state.notifications.filter((notification) => notification.id !== action.payload);
        },
        resetPerformanceNotifications: (_state) => {
            _state.notifications = [];
        },
    },
});
_a = performanceNotificationsSlice.actions, exports.setPerformanceNotifications = _a.setPerformanceNotifications, exports.addedPerformanceNotification = _a.addedPerformanceNotification, exports.updatedPerformanceNotification = _a.updatedPerformanceNotification, exports.removedPerformanceNotification = _a.removedPerformanceNotification, exports.resetPerformanceNotifications = _a.resetPerformanceNotifications;
exports.default = performanceNotificationsSlice.reducer;
